import Image from "next/image";
import Link from "next/link";
import {
  addBasePathToStrapiMedia,
  Cta,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import styles from "./CategoryCard.module.scss";

export type CategoryCardProps = {
  title: string;
  description: string;
  image: StrapiEntity<StrapiImage> | { data: null };
  backgroundText: string | null;
  technicalInformation: { label: string }[];
  cta?: Cta;
  label?: string;
};

export const CategoryCard = ({
  title,
  description,
  image,
  backgroundText,
  technicalInformation,
  cta,
  label,
}: CategoryCardProps) => {
  // Guard against null image data from Strapi
  if (!image.data) {
    return null;
  }
  const strapiImage = formatStrapiEntity(image);

  return (
    <div className={styles.cardContainer}>
      <div className={styles.backgroundTextContainer}>
        <p className={styles.backgroundText}>{backgroundText ?? title}</p>
      </div>
      <div className={styles.topRow}>
        <div className={styles.imageContainer}>
          <Image
            src={addBasePathToStrapiMedia(strapiImage)}
            alt={strapiImage.url}
            layout="fixed"
            width={299}
            height={110}
          />
        </div>
        <div className={styles.paddingRightContainer}>
          <h3 className={styles.cardTitle}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
      <div className={styles.bottomRow}>
        <div className={styles.technicalInformationContainer}>
          {technicalInformation.map((techInfo) => (
            <span key={techInfo.label} className={styles.technicalInformation}>
              {techInfo.label}
            </span>
          ))}
        </div>

        {cta && (
          <Link href={cta.url}>
            <a className={styles.cta}>{cta.label}</a>
          </Link>
        )}
        {label !== undefined && <div className={styles.label}>{label}</div>}
      </div>
    </div>
  );
};
